import type { FieldConfig, FormConfig } from '@acme/foundation';

export const createapplicationwalletaddressesformconfig = (
  includeUnchangedFields: boolean = true,
  wallets: number,
  withLabel: boolean = false
): FormConfig<Record<string, unknown>> => {
  const controls: FieldConfig<Record<string, unknown>>[] = Array.from({
    length: wallets,
  }).map((_, idx) => ({
    id: `wallet-${idx}`,
    type: 'text',
    ...(withLabel && idx === 0 ? { label: 'Адрес криптокошелька' } : {}),
    read: (ctx) => String(ctx?.[`wallet-${idx}`] ?? ''),
    write: { path: `wallet-${idx}` },
    props: {
      placeholder: 'Напишите или вставьте адрес с которого планируется перевод',
      className: 'col-span-2',
    },
  }));

  return {
    id: 'application-wallet-addresses-form',
    includeUnchangedFields,
    controls,
  };
};
